import { Phone } from '@/modules/accredited-establishments/api/types'
import { WIcon } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import {
  labelPhone,
  contactIcon,
  contactButtonName,
  getHref
} from './ContactNumbers.helpers'
import { AppLink } from '@/global/components/AppLink'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'

interface ContactNumbersProps {
  phones: Phone[]
}

const ContactNumbers: FunctionComponent<ContactNumbersProps> = ({ phones }) => {
  return (
    <div className='flex flex-col gap-1'>
      {phones.map(phone => (
        <div key={phone.number}>
          <div className='flex items-center gap-2'>
            {/*
             * `WIcon` nao tem prop de cor: ele herda a cor do texto. O token e
             * o mesmo que o `WLink` primary usa ao lado.
             */}
            <WIcon
              className='text-sys-color-content-active'
              icon={contactIcon(phone.type)}
              size='medium'
            />

            <AppLink
              as='link'
              variant='primary'
              href={getHref(phone)}
              withoutUtms
              event={{
                eventName: EventName.BUTTON_CLICKED,
                buttonType: ButtonType.NEW_PAGE,
                buttonName: contactButtonName(phone.type)
              }}
            >
              {labelPhone(phone.number)}
            </AppLink>
          </div>
        </div>
      ))}
    </div>
  )
}

export { ContactNumbers }
